/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne Swagger
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 4bcfc99b (Thu Mar  7 14:01:07 UTC 2024)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * an object containing the email and programKeys to be validated
 * @export
 * @interface ValidateInvitationFamily
 */
export interface ValidateInvitationFamily {
  /**
   * The unique identifier of the program
   * @type {Array<number>}
   * @memberof ValidateInvitationFamily
   */
  programKeys: Array<number>
  /**
   * the parents' e-mail address to which the invitation will be sent
   * @type {string}
   * @memberof ValidateInvitationFamily
   */
  email: string
}

export function ValidateInvitationFamilyFromJSON(
  json: any
): ValidateInvitationFamily {
  return ValidateInvitationFamilyFromJSONTyped(json, false)
}

export function ValidateInvitationFamilyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ValidateInvitationFamily {
  if (json === undefined || json === null) {
    return json
  }
  return {
    programKeys: json['programKeys'],
    email: json['email'],
  }
}

export function ValidateInvitationFamilyToJSON(
  value?: ValidateInvitationFamily | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    programKeys: value.programKeys,
    email: value.email,
  }
}
